import { useRouter } from "next/router";
import Link from "next/link";
import styles from "./MangaChaptersListPart.module.css";
import { useState } from "react";

const MangaChaptersListPart = ({ 
  tome, 
  volume, 
  chapter, 
  time, 
  likes, 
  chapterid, 
  chapter_title, 
  onMouseEnter, 
  onMouseLeave, 
  project_title,
  position 
}) => {
  const router = useRouter();
  const [eye, setEye] = useState("/icons/watches.png");
  
  const handleCardClick = (e) => {
    e.preventDefault();
    router.push(`/reading/${project_title}/${volume}/${chapter}`);
  };

  const date = new Date(time);
  const formattedDate = `${date.getDate().toString().padStart(2, '0')}.${(date.getMonth() + 1).toString().padStart(2, '0')}.${date.getFullYear()}`;

  const handleEyeClick = (e) => {
    e.stopPropagation();
    e.preventDefault();
    setEye(prev => prev === "/icons/watches.png" ? "/icons/not_eye.png" : "/icons/watches.png");
  };

  // Структурированные данные для каждой главы
  const chapterStructuredData = {
    '@context': 'https://schema.org',
    '@type': 'Chapter',
    'position': position,
    'name': `Глава ${chapter}${chapter_title?.trim() ? ` - ${chapter_title}` : ''}`,
    'url': `${process.env.NEXT_PUBLIC_SITE_URL || ""}/reading/${project_title}/${volume}/${chapter}`,
    'datePublished': time,
    'isPartOf': {
      '@type': 'ComicSeries',
      'name': project_title
    }
  };

  return (
    <>
      {/* Структурированные данные для SEO */}
      <script
        type="application/ld+json"
        dangerouslySetInnerHTML={{ __html: JSON.stringify(chapterStructuredData) }}
      />

      <Link
        href={`/reading/${project_title}/${volume}/${chapter}`}
        className={styles.chapterLink}
        onClick={handleCardClick}
        onMouseEnter={onMouseEnter}
        onMouseLeave={onMouseLeave}
        itemScope
        itemType="https://schema.org/Chapter"
        aria-label={`Глава ${chapter}${chapter_title?.trim() ? ` - ${chapter_title}` : ''}. Опубликовано: ${formattedDate}`}
      >
        <article className={styles.manga_chapter} role="listitem">
          <button 
            className={styles.eyeButton}
            onClick={handleEyeClick}
            aria-label={eye === "/icons/watches.png" ? "Отметить как непрочитанное" : "Отметить как прочитанное"}
          >
            <img 
              className={styles.see_icon} 
              src={eye} 
              alt={eye === "/icons/watches.png" ? "Не прочитано" : "Прочитано"} 
            />
          </button>
          
          {volume !== 0 && volume != null && (
            <span className={styles.chapter_tome} itemProp="volumeNumber">
              Том {volume}
            </span>
          )}
          
          <div className={styles.chapter_text}>
            <span className={styles.chapter_number} itemProp="name">
              Глава {chapter}
              {chapter_title?.trim() && (
                <span className={styles.chapter_title}>
                  {` - ${chapter_title}`}
                </span>
              )}
            </span>
          </div>
          
          <div className={styles.chapters_like_cont}>
            <time className={styles.updated_time} dateTime={time} itemProp="datePublished">
              {formattedDate}
            </time>
          </div>
        </article>
      </Link>
    </>
  );
};

export default MangaChaptersListPart;